/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGreeting",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
            {
                internalType: "string",
                name: "_name",
                type: "string",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class HelloUpgradeable__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
HelloUpgradeable__factory.bytecode = _bytecode;
HelloUpgradeable__factory.abi = _abi;
//# sourceMappingURL=HelloUpgradeable__factory.js.map